import React, { useEffect, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Chip from "@material-ui/core/Chip";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import useSettings from "../../hooks/useSettings";
import { toast } from 'react-toastify';
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from '../../translate/i18n.js';
import api from '../../services/api';

//import 'react-toastify/dist/ReactToastify.css';
 
const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  // ✅ CORREGIDO: Card dinámico según tema - Más compacto
  sectionCard: {
    marginBottom: theme.spacing(2),
    borderRadius: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.mode === 'dark' 
      ? '0 2px 8px rgba(0,0,0,0.3)' 
      : '0 2px 8px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: theme.mode === 'dark' 
        ? '0 4px 16px rgba(0,0,0,0.5)' 
        : '0 4px 16px rgba(0,0,0,0.15)',
      transform: 'translateY(-2px)',
    },
  },
  // ✅ CORREGIDO: Header dinámico - mantener gradiente azul pero adaptable
  sectionHeader: {
    background: theme.mode === 'dark' 
      ? 'linear-gradient(135deg, #1e40af 0%, #1e3a8a 100%)' 
      : 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
    color: 'white',
    padding: theme.spacing(2),
    borderRadius: '12px 12px 0 0',
    marginBottom: 0,
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 600,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  sectionContent: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: SettingItem dinámico según tema - Más compacto
  settingItem: {
    marginBottom: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderRadius: 8,
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e9ecef'}`,
    transition: 'all 0.2s ease',
    height: '100%',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e3f2fd',
      borderColor: theme.mode === 'dark' ? theme.palette.primary.light : '#1976d2',
    },
  },
  // ✅ CORREGIDO: Labels dinámicos según tema - Más compactos
  settingLabel: {
    fontSize: '13px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.5),
    display: 'block',
  },
  settingDescription: {
    fontSize: '11px',
    color: theme.palette.text.secondary || theme.palette.text.primary,
    marginBottom: theme.spacing(1),
    fontStyle: 'italic',
    lineHeight: 1.4,
  },
  // ✅ CORREGIDO: FormControl dinámico según tema
  formControl: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      '& fieldset': {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      fontWeight: 500,
      color: theme.palette.text.secondary || theme.palette.text.primary,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiSelect-root': {
      color: theme.palette.text.primary,
      fontSize: '13px',
      padding: theme.spacing(1.2, 1.4),
    },
    '& .MuiMenuItem-root': {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#f5f5f5',
      },
    },
  },
  statusChip: {
    fontSize: '12px',
    fontWeight: 600,
    borderRadius: 16,
    height: 24,
  },
  statusEnabled: {
    backgroundColor: theme.mode === 'dark' ? '#1f4a1f' : '#e8f5e8',
    color: theme.mode === 'dark' ? '#4ade80' : '#2e7d32',
  },
  statusDisabled: {
    backgroundColor: theme.mode === 'dark' ? '#4a1f1f' : '#ffebee',
    color: theme.mode === 'dark' ? '#f87171' : '#c62828',
  },
  // ✅ CORREGIDO: Divider dinámico según tema
  divider: {
    margin: theme.spacing(2, 0),
    backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
  },
  // ✅ Estilos para TextField en modo dark
  textFieldInput: {
    backgroundColor: theme.mode === 'dark' ? '#374151' : 'transparent',
    color: theme.palette.text.primary,
    '& .MuiOutlinedInput-input': {
      color: theme.palette.text.primary,
    },
  },
  textFieldLabel: {
    color: theme.palette.text.secondary || theme.palette.text.primary,
  },
  loadingText: {
    fontSize: '12px',
    color: theme.palette.primary.main,
    fontStyle: 'italic',
  },
  // ✅ CORREGIDO: TextField dinámico según tema
  textField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: theme.mode === 'dark' ? '#374151' : theme.palette.background.paper,
      color: theme.palette.text.primary,
      '& fieldset': {
        borderColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
    '& .MuiInputLabel-root': {
      color: theme.palette.text.secondary || theme.palette.text.primary,
      '&.Mui-focused': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiFormHelperText-root': {
      color: theme.palette.text.secondary || theme.palette.text.primary,
    },
  },
}));

// Componente helper para renderizar configuraciones individuales
const SettingItem = ({ 
  label, 
  description, 
  value, 
  onChange, 
  options, 
  loading, 
  classes,
  invertStatus = false  // ✅ Nueva prop para invertir la lógica del estado
}) => {
  const getStatusChip = (val) => {
    // ✅ Lógica invertida para settings donde "disabled" = habilitado (como callAutoMessage)
    let isEnabled;
    if (invertStatus) {
      isEnabled = val === 'disabled' || val === 'no';
    } else {
      isEnabled = val === 'enabled' || val === 'yes';
    }
    return (
      <Chip
        label={isEnabled ? i18n.t("settings.states.enabled") : i18n.t("settings.states.disabled")}
        className={`${classes.statusChip} ${isEnabled ? classes.statusEnabled : classes.statusDisabled}`}
        size="small"
      />
    );
  };

  return (
    <Box className={classes.settingItem}>
      <Typography className={classes.settingLabel}>
        {label}
      </Typography>
      {description && (
        <Typography className={classes.settingDescription}>
          {description}
        </Typography>
      )}
      <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
        <FormControl className={classes.formControl} variant="outlined" style={{ flex: 1, minWidth: 150 }}>
          <InputLabel>{label}</InputLabel>
          <Select
            value={value}
            onChange={onChange}
            label={label}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {loading && (
            <FormHelperText className={classes.loadingText}>
              {i18n.t("settings.states.updating")}
            </FormHelperText>
          )}
        </FormControl>
        {getStatusChip(value)}
      </Box>
    </Box>
  );
};

export default function Options(props) {
  const { settings, scheduleTypeChanged } = props;
  const classes = useStyles();

 

  const [userRating, setUserRating] = useState("disabled");
  const [scheduleType, setScheduleType] = useState("disabled");
  const [callType, setCallType] = useState("enabled");
  const [chatbotType, setChatbotType] = useState("");
  const [CheckMsgIsGroup, setCheckMsgIsGroupType] = useState("enabled");
  const [callAutoMessage, setCallAutoMessage] = useState("");
  const [savedCallAutoMessage, setSavedCallAutoMessage] = useState(""); // ✅ Valor guardado en BD

  const [loadingUserRating, setLoadingUserRating] = useState(false);
  const [loadingScheduleType, setLoadingScheduleType] = useState(false);
      const [loadingCallType, setLoadingCallType] = useState(false);
  const [loadingChatbotType, setLoadingChatbotType] = useState(false);
  const [loadingCheckMsgIsGroup, setLoadingCheckMsgIsGroup] = useState(false);
  const [loadingCallAutoMessage, setLoadingCallAutoMessage] = useState(false);
 
  // Configuración de zona horaria para campañas
  const [timezoneType, setTimezoneType] = useState(""); // ✅ Inicializar vacío para evitar warning
  const [loadingTimezoneType, setLoadingTimezoneType] = useState(false);
  const [timezones, setTimezones] = useState([]); // ✅ DB-FIRST: Lista dinámica de timezones
  const [loadingTimezones, setLoadingTimezones] = useState(true);
  
  const [SendGreetingAccepted, setSendGreetingAccepted] = useState("disabled");
  const [loadingSendGreetingAccepted, setLoadingSendGreetingAccepted] = useState(false);
  
  const [SettingsTransfTicket, setSettingsTransfTicket] = useState("disabled");
  const [loadingSettingsTransfTicket, setLoadingSettingsTransfTicket] = useState(false);
  
  const [sendGreetingMessageOneQueues, setSendGreetingMessageOneQueues] = useState("disabled");
  const [loadingSendGreetingMessageOneQueues, setLoadingSendGreetingMessageOneQueues] = useState(false);

  // ✅ NUEVO: Configuración de Firmas Internas
  const [internalSignature, setInternalSignature] = useState("disabled");
  const [loadingInternalSignature, setLoadingInternalSignature] = useState(false);

  // ✅ NUEVO: Configuración de Validación de Números de WhatsApp
  const [validateWhatsAppNumbers, setValidateWhatsAppNumbers] = useState("disabled");
  const [loadingValidateWhatsAppNumbers, setLoadingValidateWhatsAppNumbers] = useState(false);

  const { update } = useSettings();

  useEffect(() => {
    if (Array.isArray(settings) && settings.length) {
      const userRating = settings.find((s) => s.key === "userRating");
      if (userRating) {
        setUserRating(userRating.value);
      }
      const scheduleType = settings.find((s) => s.key === "scheduleType");
      if (scheduleType) {
        setScheduleType(scheduleType.value);
      }
      const callType = settings.find((s) => s.key === "call");
      if (callType) {
        setCallType(callType.value);
      }
      const callAutoMessageSetting = settings.find((s) => s.key === "callAutoMessage");
      if (callAutoMessageSetting) {
        setCallAutoMessage(callAutoMessageSetting.value);
        setSavedCallAutoMessage(callAutoMessageSetting.value); // ✅ Guardar valor original de BD
      } else {
        // Si no existe, usar valor por defecto
        const defaultMessage = "*Mensaje Automático:*\n\nLas llamadas de voz y video están deshabilitadas para este WhatsApp, favor enviar un mensaje de texto. Gracias";
        setCallAutoMessage(defaultMessage);
        setSavedCallAutoMessage(defaultMessage);
      }
      const CheckMsgIsGroup = settings.find((s) => s.key === "CheckMsgIsGroup");
      if (CheckMsgIsGroup) {
        setCheckMsgIsGroupType(CheckMsgIsGroup.value);
      }

      const SendGreetingAccepted = settings.find((s) => s.key === "sendGreetingAccepted");
      if (SendGreetingAccepted) {
        setSendGreetingAccepted(SendGreetingAccepted.value);
      }
	  
	  const SettingsTransfTicket = settings.find((s) => s.key === "sendMsgTransfTicket");
      if (SettingsTransfTicket) {
        setSettingsTransfTicket(SettingsTransfTicket.value);
      }

      const sendGreetingMessageOneQueues = settings.find((s) => s.key === "sendGreetingMessageOneQueues");
      if (sendGreetingMessageOneQueues) {
        setSendGreetingMessageOneQueues(sendGreetingMessageOneQueues.value)
      }

      // ✅ NUEVO: Cargar configuración de Firmas Internas
      const internalSignatureSetting = settings.find((s) => s.key === "internalSignature");
      if (internalSignatureSetting) {
        setInternalSignature(internalSignatureSetting.value);
      }

      // ✅ NUEVO: Cargar configuración de Validación de Números de WhatsApp
      const validateWhatsAppNumbersSetting = settings.find((s) => s.key === "validateWhatsAppNumbers");
      if (validateWhatsAppNumbersSetting) {
        setValidateWhatsAppNumbers(validateWhatsAppNumbersSetting.value);
      } else {
        // Valor por defecto: disabled
        setValidateWhatsAppNumbers("disabled");
      }

      const chatbotType = settings.find((s) => s.key === "chatBotType");
      if (chatbotType) {
        setChatbotType(chatbotType.value);
      }

      const timezoneType = settings.find((s) => s.key === "timezone");
      if (timezoneType && timezoneType.value) {
        // ✅ Guardar en cache, pero NO establecer todavía (se establecerá cuando los timezones se carguen)
        localStorage.setItem("campaignTimezone", timezoneType.value);
      } else {
        // ✅ CORRECCIÓN: Usar fallback unificado (America/Lima, compatible con install.sh)
        const defaultTimezone = "America/Lima";
        localStorage.setItem("campaignTimezone", defaultTimezone);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  // ✅ DB-FIRST: Cargar timezones dinámicamente desde la base de datos
  useEffect(() => {
    const loadTimezones = async () => {
      try {
        setLoadingTimezones(true);
        const { data } = await api.get('/settings/timezones');
        if (data && data.success && data.data) {
          setTimezones(data.data);
          
          // ✅ CORRECCIÓN: Establecer timezoneType SOLO después de cargar timezones
          // Esto evita el warning de Material-UI de "out-of-range value"
          const savedTimezone = localStorage.getItem("campaignTimezone") || "America/Lima";
          // Verificar que el timezone guardado existe en la lista cargada
          const exists = data.data.some(tz => tz.timezone === savedTimezone);
          const finalTimezone = exists ? savedTimezone : "America/Lima";
          setTimezoneType(finalTimezone);
          // Actualizar localStorage con el timezone válido
          localStorage.setItem("campaignTimezone", finalTimezone);
        } else {
          // Fallback: Si falla, usar lista hardcodeada mínima
          console.warn('No se pudieron cargar timezones desde BD, usando fallback');
          setTimezones([
            { timezone: 'America/Lima', displayName: 'Perú (America/Lima)', region: 'America' }
          ]);
          if (!timezoneType || timezoneType === "") {
            setTimezoneType("America/Lima");
          }
        }
      } catch (error) {
        console.error('Error cargando timezones:', error);
        // Fallback: Lista mínima
        setTimezones([
          { timezone: 'America/Lima', displayName: 'Perú (America/Lima)', region: 'America' }
        ]);
        if (!timezoneType || timezoneType === "") {
          setTimezoneType("America/Lima");
        }
      } finally {
        setLoadingTimezones(false);
      }
    };
    
    loadTimezones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function handleChangeUserRating(value) {
    setUserRating(value);
    setLoadingUserRating(true);
    await update({
      key: "userRating",
      value,
    });
    toast.success(i18n.t("settings.success"));
    setLoadingUserRating(false);
  }

  async function handleSendGreetingMessageOneQueues(value) {
    setSendGreetingMessageOneQueues(value);
    setLoadingSendGreetingMessageOneQueues(true);
    await update({
      key: "sendGreetingMessageOneQueues",
      value,
    });
	toast.success(i18n.t("settings.success"));
    setLoadingSendGreetingMessageOneQueues(false);
  }

  // ✅ NUEVO: Función para manejar cambio de Firmas Internas
  async function handleInternalSignature(value) {
    setInternalSignature(value);
    setLoadingInternalSignature(true);
    await update({
      key: "internalSignature",
      value,
    });
    toast.success(i18n.t("settings.success"));
    setLoadingInternalSignature(false);
  }

  // ✅ NUEVO: Función para manejar cambio de Validación de Números de WhatsApp
  async function handleValidateWhatsAppNumbers(value) {
    setValidateWhatsAppNumbers(value);
    setLoadingValidateWhatsAppNumbers(true);
    await update({
      key: "validateWhatsAppNumbers",
      value,
    });
    toast.success(i18n.t("settings.success"));
    setLoadingValidateWhatsAppNumbers(false);
  }

  async function handleScheduleType(value) {
    setScheduleType(value);
    setLoadingScheduleType(true);
    await update({
      key: "scheduleType",
      value,
    });
    toast.success(i18n.t("settings.success"));
    setLoadingScheduleType(false);
    scheduleTypeChanged(value);
  }

  async function handleCallType(value) {
    setCallType(value);
    setLoadingCallType(true);
    await update({
      key: "call",
      value,
    });
    toast.success(i18n.t("settings.success"));
    setLoadingCallType(false);
  }

  async function handleCallAutoMessage(value) {
    if (value.length > 500) {
      toast.error(i18n.t("settings.options.callAutoMessageMaxLength"));
      return;
    }
    setLoadingCallAutoMessage(true);
    try {
      await update({
        key: "callAutoMessage",
        value,
      });
      setCallAutoMessage(value);
      setSavedCallAutoMessage(value); // ✅ Actualizar valor guardado después de éxito
      toast.success(i18n.t("settings.success"));
    } catch (error) {
      toast.error(i18n.t("settings.options.callAutoMessageSaveError"));
      console.error("Error guardando callAutoMessage:", error);
      setCallAutoMessage(savedCallAutoMessage); // ✅ Restaurar valor anterior si falla
    } finally {
      setLoadingCallAutoMessage(false);
    }
  }

  function handleRestoreDefaultMessage() {
    const defaultMessage = "*Mensaje Automático:*\n\nLas llamadas de voz y video están deshabilitadas para este WhatsApp, favor enviar un mensaje de texto. Gracias";
    handleCallAutoMessage(defaultMessage);
  }

  async function handleChatbotType(value) {
    setChatbotType(value);
    setLoadingChatbotType(true);
    await update({
      key: "chatBotType",
      value,
    });
    toast.success(i18n.t("settings.success"));
    setLoadingChatbotType(false);
  }

  async function handleGroupType(value) {
    setCheckMsgIsGroupType(value);
    setLoadingCheckMsgIsGroup(true);
    await update({
      key: "CheckMsgIsGroup",
      value,
    });
    toast.success(i18n.t("settings.success"));
    setLoadingCheckMsgIsGroup(false);
  }
  
  async function handleSendGreetingAccepted(value) {
    setSendGreetingAccepted(value);
    setLoadingSendGreetingAccepted(true);
    await update({
      key: "sendGreetingAccepted",
      value,
    });
	toast.success(i18n.t("settings.success"));
    setLoadingSendGreetingAccepted(false);
  }  

  async function handleSettingsTransfTicket(value) {
    setSettingsTransfTicket(value);
    setLoadingSettingsTransfTicket(true);
    await update({
      key: "sendMsgTransfTicket",
      value,
    });

    toast.success(i18n.t("settings.success"));
    setLoadingSettingsTransfTicket(false);
  } 
 


  async function handleChangeTimezone(value) {
    setTimezoneType(value);
    setLoadingTimezoneType(true);
    await update({
      key: "timezone",
      value,
    });
    // ✅ CORRECCIÓN: Guardar en cache específico para campañas
    localStorage.setItem("campaignTimezone", value);
    toast.success(i18n.t("settings.success"));
    setLoadingTimezoneType(false);
  }

  return (
    <Box className={classes.container}>
      {/* CONFIGURACIONES PRINCIPALES */}
      <Card className={classes.sectionCard}>
        <Box className={classes.sectionHeader}>
          <Typography className={classes.sectionTitle}>
            <span role="img" aria-label="Configuraciones">⚙️</span> {i18n.t("settings.options.mainSettings")}
          </Typography>
        </Box>
        <CardContent className={classes.sectionContent}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.userRating")}
                description={i18n.t("settings.options.userRatingDesc")}
                value={userRating}
                onChange={(e) => handleChangeUserRating(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingUserRating}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.scheduleType")}
                description={i18n.t("settings.options.scheduleTypeDesc")}
                value={scheduleType}
                onChange={(e) => handleScheduleType(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "queue", label: i18n.t("settings.states.queue") },
                  { value: "company", label: i18n.t("settings.states.company") }
                ]}
                loading={loadingScheduleType}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.ignoreGroupMessages")}
                description={i18n.t("settings.options.ignoreGroupMessagesDesc")}
                value={CheckMsgIsGroup}
                onChange={(e) => handleGroupType(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.deactivated") },
                  { value: "enabled", label: i18n.t("settings.states.activated") }
                ]}
                loading={loadingCheckMsgIsGroup}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.sendCallAutoMessage")}
                description={i18n.t("settings.options.sendCallAutoMessageDesc")}
                value={callType}
                onChange={(e) => handleCallType(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.enabled") },
                  { value: "enabled", label: i18n.t("settings.states.disabled") }
                ]}
                loading={loadingCallType}
                classes={classes}
                invertStatus={true}  // ✅ Invertir lógica: "disabled" = Habilitado, "enabled" = Deshabilitado
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.chatbotType")}
                description={i18n.t("settings.options.chatbotTypeDesc")}
                value={chatbotType}
                onChange={(e) => handleChatbotType(e.target.value)}
                options={[
                  { value: "text", label: i18n.t("settings.states.text") }
                ]}
                loading={loadingChatbotType}
                classes={classes}
              />
            </Grid>
          </Grid>

          {/* Campo para editar mensaje automático - Solo visible si está Habilitado (disabled) */}
          {callType === "disabled" && (
            <Box className={classes.settingItem} style={{ marginTop: 16 }}>
              <Typography className={classes.settingLabel}>
                {i18n.t("settings.options.callAutoMessage")}
              </Typography>
              <Typography className={classes.settingDescription}>
                {i18n.t("settings.options.callAutoMessageDesc")}
              </Typography>
              <Box display="flex" flexDirection="column" gap={2} mt={2}>
                <TextField
                  multiline
                  rows={4}
                  fullWidth
                  variant="outlined"
                  value={callAutoMessage}
                  onChange={(e) => {
                    const newValue = e.target.value;
                    if (newValue.length <= 500) {
                      setCallAutoMessage(newValue);
                    }
                  }}
                  onBlur={(e) => {
                    const newValue = e.target.value;
                    // ✅ Comparar contra el valor GUARDADO en BD, no contra el estado actual
                    if (savedCallAutoMessage !== newValue) {
                      handleCallAutoMessage(newValue);
                    }
                  }}
                  placeholder={i18n.t("settings.options.callAutoMessagePlaceholder")}
                  helperText={`${callAutoMessage.length}/500 ${i18n.t("settings.options.characters")}`}
                  disabled={loadingCallAutoMessage}
                  InputProps={{
                    className: classes.textFieldInput
                  }}
                  InputLabelProps={{
                    className: classes.textFieldLabel
                  }}
                />
                <Box display="flex" gap={2} alignItems="center">
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleRestoreDefaultMessage}
                    disabled={loadingCallAutoMessage}
                    size="small"
                  >
                    {i18n.t("settings.options.restoreDefault")}
                  </Button>
                  {loadingCallAutoMessage && (
                    <Typography variant="caption" color="textSecondary">
                      {i18n.t("settings.states.updating")}
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          )}
        </CardContent>
      </Card>

      {/* CONFIGURACIONES DE MENSAJERÍA */}
      <Card className={classes.sectionCard}>
        <Box className={classes.sectionHeader}>
          <Typography className={classes.sectionTitle}>
            <span role="img" aria-label="Mensajería">💬</span> {i18n.t("settings.options.messagingSettings")}
          </Typography>
        </Box>
        <CardContent className={classes.sectionContent}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.sendGreetingAccepted")}
                description={i18n.t("settings.options.sendGreetingAcceptedDesc")}
                value={SendGreetingAccepted}
                onChange={(e) => handleSendGreetingAccepted(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingSendGreetingAccepted}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.sendTransferMessage")}
                description={i18n.t("settings.options.sendTransferMessageDesc")}
                value={SettingsTransfTicket}
                onChange={(e) => handleSettingsTransfTicket(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingSettingsTransfTicket}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.sendGreetingOneQueue")}
                description={i18n.t("settings.options.sendGreetingOneQueueDesc")}
                value={sendGreetingMessageOneQueues}
                onChange={(e) => handleSendGreetingMessageOneQueues(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingSendGreetingMessageOneQueues}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.internalSignature")}
                description={i18n.t("settings.options.internalSignatureDesc")}
                value={internalSignature}
                onChange={(e) => handleInternalSignature(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingInternalSignature}
                classes={classes}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <SettingItem
                label={i18n.t("settings.options.validateWhatsAppNumbers")}
                description={i18n.t("settings.options.validateWhatsAppNumbersDesc")}
                value={validateWhatsAppNumbers}
                onChange={(e) => handleValidateWhatsAppNumbers(e.target.value)}
                options={[
                  { value: "disabled", label: i18n.t("settings.states.disabled") },
                  { value: "enabled", label: i18n.t("settings.states.enabled") }
                ]}
                loading={loadingValidateWhatsAppNumbers}
                classes={classes}
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      {/* ZONA HORARIA PARA CAMPAÑAS - Fuera de subpestañas */}
      <Card className={classes.sectionCard}>
        <Box className={classes.sectionHeader}>
          <Typography className={classes.sectionTitle}>
            <span role="img" aria-label="Zona Horaria">🌍</span> {i18n.t("settings.options.timezoneForCampaigns")}
          </Typography>
        </Box>
        <CardContent className={classes.sectionContent}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Box className={classes.settingItem}>
                <Typography className={classes.settingLabel}>
                  <span role="img" aria-label="Zona Horaria">🌍</span> {i18n.t("settings.options.timezoneForCampaigns")}
                </Typography>
                <Typography className={classes.settingDescription}>
                  {i18n.t("settings.options.timezoneForCampaignsDesc")}
                </Typography>
                <FormControl className={classes.formControl} variant="outlined" fullWidth>
                  <InputLabel>{i18n.t("settings.options.timezone")}</InputLabel>
                  <Select
                    value={loadingTimezones || timezones.length === 0 ? "" : timezoneType}
                    onChange={(e) => handleChangeTimezone(e.target.value)}
                    label={i18n.t("settings.options.timezone")}
                    disabled={loadingTimezones || timezones.length === 0}
                  >
                    {loadingTimezones ? (
                      <MenuItem value="" disabled>Cargando timezones...</MenuItem>
                    ) : timezones.length > 0 ? (
                      // ✅ DB-FIRST: Renderizar dinámicamente desde la base de datos
                      timezones.map((tz) => (
                        <MenuItem key={tz.id || tz.timezone} value={tz.timezone}>
                          {tz.displayName}
                        </MenuItem>
                      ))
                    ) : (
                      // Fallback: Lista mínima si no hay datos
                      <>
                        <MenuItem value="America/Lima">Perú (America/Lima)</MenuItem>
                        <MenuItem value="America/Bogota">Colombia (America/Bogota)</MenuItem>
                      </>
                    )}
                  </Select>
                  {loadingTimezoneType && (
                    <FormHelperText className={classes.loadingText}>
                      {i18n.t("settings.states.updating")}
                    </FormHelperText>
                  )}
                </FormControl>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

    </Box>
  );
}